import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AmparosComponent} from "../../amparos.component";
import {ProtectionService} from "../../../../../../core/services/parameters/protection.service";

@Component({
  selector: 'confirm-delete',
  templateUrl: './confirm-delete-protection.component.html',
  styleUrls: ['./confirm-delete-protection.component.scss']
})
export class ConfirmDeleteProtectionComponent implements OnInit {

  id: number;

  constructor(
    public dialogRef: MatDialogRef<AmparosComponent>,
    private protectionService: ProtectionService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.id = this.data.id;
  }

  submit() {
    if (this.id !== undefined || this.id !== null)
      this.protectionService.deleteProtection(this.id).subscribe(_res => {
        this.dialogRef.close(true);
      })
  }

  onNoClick(b: boolean) {
    this.dialogRef.close(b);
  }
}
